import {Pipe, PipeTransform} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Pipe({
  name: 'getFormGroup'
})
export class GetFormGroupPipe implements PipeTransform {

  transform(form: FormGroup, controlId: string): FormGroup {
    return form.get(controlId) as FormGroup;
  }

}
